import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="EVA settled" visualizer="full" networkBackground="full">
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
